import { RENEW_DASH_COLOR } from "../../constants/constants";
import styles from "./guideBlock.module.scss";

function Item({ color, text }) {
	return (
		<div className={styles['guide-item']}>
			<div className={styles['guide-item__palette']} style={{ backgroundColor: color }}/>
			<div className={styles['guide-item__text']}>{text}</div>
		</div>
	)
}

export default function GuideBlock() {
	return (
		<div className={styles.block}>
			<div className={styles.block__head}>
				<div className={styles.block__title}>지역별 설비보급량</div>
			</div>

			<div className={styles.block__body}>
				<Item color={RENEW_DASH_COLOR[0].bgColor} text="1,000개소 미만"/>
				<Item color={RENEW_DASH_COLOR[1].bgColor} text="1,000이상 ~ 3,000미만개소"/>
				<Item color={RENEW_DASH_COLOR[2].bgColor} text="3,000이상 ~ 5,000미만개소"/>
				<Item color={RENEW_DASH_COLOR[3].bgColor} text="5,000이상 개소"/>
			</div>
		</div>
	)
}